import type { FocusEvent } from 'react'
import React from 'react'

import { Input, Loader, Loading, Subsection } from '@fourthwall/components'
import { useFormikContext } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../Domain.types'
import * as S from './InternalDomain.styled'
import { useInternalDomain } from './hooks/useInternalDomain'

export const InternalDomain = () => {
  const { isCheckingSlugAvailability, isChangingSlug, getDomainUrl, checkSlugAvailability } =
    useInternalDomain()
  const formik = useFormikContext<FormValues>()

  const handleInternalDomainBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (formik.values.internalDomain !== formik.initialValues.internalDomain) {
      checkSlugAvailability(formik.values.internalDomain, formik)
    }

    formik.getFieldProps('internalDomain').onBlur(event)
  }

  const renderInput = () => {
    if (isChangingSlug) {
      return (
        <Input
          disabled
          {...formik.getFieldProps('internalDomain')}
          value={getDomainUrl(formik.getFieldProps('internalDomain').value)}
          append={
            <S.AppendLoaderContainer>
              <Loader />
            </S.AppendLoaderContainer>
          }
          suggestion="Your new domain is being processed. This usually takes about an hour."
        />
      )
    }

    return (
      <Loading isLoading={isCheckingSlugAvailability} size="small">
        <Input
          append={
            <S.AppendContainer>
              <span>{getDomainUrl()}</span>
            </S.AppendContainer>
          }
          disabled={isCheckingSlugAvailability}
          showAppend
          {...formik.getFieldProps('internalDomain')}
          onBlur={handleInternalDomainBlur}
        />
      </Loading>
    )
  }

  return (
    <Subsection title="Fourthwall domain">
      <S.Container>
        <p>Change your free Fourthwall domain name for your site.</p>

        {renderInput()}
      </S.Container>
    </Subsection>
  )
}
